import { render } from "./History.vue?vue&type=template&id=b55563d2&scoped=true&ts=true"
import script from "./History.vue?vue&type=script&setup=true&lang=ts"
export * from "./History.vue?vue&type=script&setup=true&lang=ts"

import "./History.vue?vue&type=style&index=0&id=b55563d2&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b55563d2"],['__file',"src/views/me/History.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b55563d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b55563d2', __exports__)) {
    console.log('reload')
    api.reload('b55563d2', __exports__)
  }
  
  module.hot.accept("./History.vue?vue&type=template&id=b55563d2&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('b55563d2', render)
  })

}


export default __exports__